'use strict';
(function($){
	/*
	 * Vetology.AISettings widget
	 *
	 * @description This is the main Vetology AISettings widget that needs a description right here
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.AISettings',
		{
			"options": {
				"body": $('.ai_plans_body')
			},
			/*
			 * Vetology.AISettings._init
			 *
			 * @description	Initializes the Vetology.AISettings
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				$.get("/vetology_asset/html/ai_pricing.html", function(data, textStatus, jqxhr){
					o.options.row = data;
					o._initEvents();
				});
			},
			/*
			 * Vetology.AISettings._doSomething
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_initEvents": function(){
				var o = this;
				$("body").on("click", ".ai-pricing-plan-remove,.ai-pricing-plan-undo-remove,.ai_add_princing", function(){
					var el = $(this);
					if(el.hasClass("ai_add_princing")){
						var lastRow = o.options.body.find('tr').length - 1;
						lastRow ++;
						var row = o.options.row.replace(new RegExp('{index}', 'g'), lastRow);
						o.options.body.append(row);
					} else {
						var row = el.closest("tr");
						row.toggleClass("bg-danger").toggleClass("trash_on_post");
						row.find('.ai-pricing-plan-remove').toggleClass("hide");
						row.find('.ai-pricing-plan-undo-remove').toggleClass("hide");
						var toggle = row.find('input[type=text]').prop('disabled') ? false : true;
						row.find('input[type=text]').prop('disabled', toggle);
						row.find('select').prop('disabled', toggle);
						row.find('textarea').prop('disabled', toggle);
						row.find('.ai_remove_toggle').val((toggle ? 1 : 0));
					}
				});
			}
		}
	);
})(jQuery);